import ApiClientWithCredentials from "@/lib/api-client";
import Settings from "@/constants/settings";
import { AxiosResponse } from "axios";
import { ISelectOption } from "@/models/select-option";

export default {
  async getIrregularReasons(): Promise<ISelectOption[]> {
    return await ApiClientWithCredentials.get(
      `${Settings.API_V1}/irregular_reasons`
    ).then((response: AxiosResponse<ISelectOption[]>) => {
      return response.data as ISelectOption[];
    });
  },
};
